import { AfterViewInit, Component, input, signal } from '@angular/core';
import { fromEvent, map, throttleTime } from 'rxjs';
import { getWindow } from 'src/app/helpers/window';

@Component({
  selector: 'app-toolbar',
  imports: [],
  templateUrl: './toolbar.component.html',
  styleUrl: './toolbar.component.scss',
})
export class ToolbarComponent implements AfterViewInit {
  scrollableElement = input<HTMLDivElement | Document>();
  indicatorWidth = signal(0);

  ngAfterViewInit(): void {
    const scrollableElementRef = this.scrollableElement();
    if (!scrollableElementRef) return;

    const isDocument = 'documentElement' in scrollableElementRef;
    const element = isDocument ? scrollableElementRef.documentElement : scrollableElementRef;

    fromEvent(isDocument ? scrollableElementRef : element, 'scroll')
      .pipe(
        throttleTime(50),
        map(() => {
          const { scrollTop, scrollHeight, clientHeight } = element;
          const height = isDocument ? getWindow()?.innerHeight : clientHeight;
          const percent = Math.round(100 * (scrollTop / (scrollHeight - (height ?? 0))));
          const adjustedPercent = percent > 95 ? 100 : percent < 5 ? 0 : percent;
          return adjustedPercent;
        })
      )
      .subscribe((percent) => {
        this.indicatorWidth.set(percent);
      });
  }
}
